import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  if (document.querySelector(".splide01")) {
    new Splide(".splide01", {
      type: "fade",
      rewind: true,
      perPage: 1,
      perMove: 1,
      speed: 1200,
      autoplay: true,
      interval: 5000,
      pauseOnHover: false,
      pagination: false,
      arrows: true,
      focus: false,
      updateOnMove: false,
    }).mount();
  }
  if (document.querySelector(".splide02")) {
    new Splide(".splide02", {
      perPage: 3,
      type: "loop",
      focus: 0,
      autoScroll: {
        speed: 2,
      },
    }).mount({ AutoScroll });
  }
}
